import { withProfiler } from "@sentry/react";
import type { FC } from "react";

import type { Flipper } from "@shared/types/flipper";
import type { PractitionerType } from "@unauthenticated/shared/data/types";
import { ErrorBoundary, Providers } from "@unauthenticated/signupSignin/components";
import { ExternalPractitionerPage } from "@unauthenticated/signupSignin/scenes";

interface Props {
  currentCountry: string;
  practitionerTypes: PractitionerType[];
  emailRegex: string;
  additionalAttributes?: any;
  csuid: string;
  flippers: Flipper[];
  e2e: boolean;
  analyticsAnonymousId: string;
}

const ExternalPractitionerSignUpPage: FC<Props> = ({
  currentCountry,
  practitionerTypes,
  emailRegex,
  additionalAttributes,
  csuid,
  flippers,
  e2e,
  analyticsAnonymousId,
}) => {
  return (
    <Providers
      emailRegex={emailRegex}
      currentCountry={currentCountry}
      flippers={flippers}
      e2e={e2e}
      analyticsAnonymousId={analyticsAnonymousId}
    >
      <ErrorBoundary {...{ csuid, flippers }}>
        <ExternalPractitionerPage
          practitionerTypes={practitionerTypes}
          additionalAttributes={additionalAttributes}
          csuid={csuid}
        />
      </ErrorBoundary>
    </Providers>
  );
};

const ExternalPractitionerSignUpPageWithProfiler = withProfiler(ExternalPractitionerSignUpPage);
export { ExternalPractitionerSignUpPageWithProfiler as ExternalPractitionerSignUpPage };
